import React from 'react';
import { Row } from '@commonsku/styles';
import Form from './form/AccountStatus';
import useDistributorStatus from './hooks/useDistributorStatus';
import TopInfo from './misc/Info';

export default function AdminDistributorStatus() {
    const [items, loading, save, remove] = useDistributorStatus();

    const list = items.map((item, index) => {
        return (
            <div key={item.account_status_id} data-testid={`row-${index}`}>
                <Row>
                    <Form item={item} saveItem={save} deleteItem={remove} />
                </Row>
            </div>
        );
    });

    const add = (
        <Row>
            <Form saveItem={save} />
        </Row>
    );

    return (
        <>
            <TopInfo message='Create custom statuses to help segment your distributors on your Distributors tab.' />
            {list}
            {add}
        </>
    );
}
